<template>
  <!-- Static sidebar for desktop -->
  <div class="hidden md:flex md:flex-shrink-0">
    <div class="flex flex-col w-64 bg-gray-800">
      <div class="h-0 flex-1 flex flex-col pt-3 pb-4 overflow-y-auto">
        <div class="flex items-center flex-shrink-0 px-2">
          <account v-slot:default="{ currentAccount, loading, accounts }">
            <b-dropdown v-slot:default="{ isOpen, toggle }">
              <div class="min-w-0">
                <button
                  @click="toggle"
                  class="px-2 py-2 flex items-center justify-between w-full text-gray-200 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150 rounded"
                  :class="{ 'bg-gray-700': isOpen }"
                >
                  <div class="flex items-center min-w-0">
                    <div
                      v-if="!loading"
                      class="flex flex-shrink-0 w-10 h-10 bg-gray-900 rounded justify-center items-center text-2xl"
                    >{{ currentAccount.company_name.charAt(0) }}</div>
                    <div class="ml-4 pr-4 w-64 text-left min-w-0" v-if="!loading">
                      <div class="truncate">{{ currentAccount.company_name }}</div>
                      <div class="text-sm font-light">ID #{{ currentAccount.id }}</div>
                    </div>
                  </div>

                  <font-awesome-icon icon="chevron-down"></font-awesome-icon>
                </button>

                <transition
                  enter-active-class="transition-opacity ease-linear duration-100"
                  enter-class="opacity-0"
                  enter-to-class="opacity-100"
                  leave-active-class="transition-opacity ease-linear duration-100"
                  leave-class="opacity-100"
                  leave-to-class="opacity-0"
                >
                  <div
                    class="absolute bg-white md:ml-24 text-gray-900 w-64 rounded shadow-lg border mt-2 z-10"
                    v-if="!loading && isOpen"
                  >
                    <account-settings :user="user" :accounts="accounts" />
                  </div>
                </transition>
              </div>
            </b-dropdown>
          </account>
        </div>
        <!-- Sidebar component, swap this element with another sidebar if you like -->
        <nav class="mt-4 flex-1 px-2 bg-gray-800">
          <slot />
        </nav>
      </div>
      <!-- TODO Footer for desktop
      <div class="flex-shrink-0 flex bg-gray-700 p-4"></div>
      -->

      <div class="flex-shrink-0 flex flex-col p-4 pl-5">
        <button
          @click="$store.dispatch('search/open');"
          class="flex items-center text-gray-400 text-sm hover:text-gray-300 text-left focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700 rounded"
        >
          <div>
            <font-awesome-icon :icon="['far', 'search']" />
          </div>

          <div class="ml-3">Suchen</div>
          <div class="ml-4 flex text-xs">
            <div
              class="rounded bg-gray-900 w-5 h-5 flex justify-center items-center"
              v-if="isOSX()"
            >⌘</div>
            <div class="rounded bg-gray-900 px-1 h-5 flex justify-center items-center" v-else>Strg</div>
            <div class="ml-1 rounded bg-gray-900 w-5 h-5 flex justify-center items-center">K</div>
          </div>
        </button>
        <a href="#" class="mt-2 text-gray-400 text-sm hover:text-gray-300 hidden">
          <span class="w-5">
            <font-awesome-icon :icon="['far', 'comment-lines']" />
          </span>

          <span class="ml-3">Feedback</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Account from "@/components/Account";
import BDropdown from "@/components/BDropdown";
import AccountSettings from "./AccountSettings";

import InteractsWithShortcuts from "@/mixins/InteractsWithShortcuts";

export default {
  components: { Account, BDropdown, AccountSettings },
  mixins: [InteractsWithShortcuts],
  computed: {
    user() {
      return this.$store.state.authentication.keycloak;
    },
  },
};
</script>
